import { FormikContext } from 'formik'
import { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormik } from '../../../../../common/hooks/formik'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { PureSwitcher } from '../../../../../common/ui/pure-switcher/pure-switcher'
import { useFBField } from '../../form-builder.context'
import { FormBuilderConfig } from '../../types/form-builder.types'

type ImageConfigProps = { label?: string; required?: boolean }

export const ImageConfig = ({ label, required = false }: ImageConfigProps) => {
  const { t } = useTranslation()
  const { value: configValue, setValue } = useFBField()
  const formik = useFormik<ImageConfigProps>({
    initialValues: {
      label: label || '',
    },
    enableReinitialize: true,
    validationSchema: {},
    onSubmit: (values) => {
      console.log('values', values)
    },
  })

  const handleChange = (key: string, value: BaseSyntheticEvent) => {
    setValue({ ...configValue, [key]: value.target.value } as unknown as FormBuilderConfig)
  }

  const handleSwitchChange = (key: string, value: boolean) => {
    setValue({ ...configValue, [key]: value } as unknown as FormBuilderConfig)
  }

  return (
    <FormikContext.Provider value={formik as any}>
      <form onSubmit={formik.handleSubmit}>
        <PureInput
          {...formik.getFieldProps('label')}
          name="label"
          onInput={(e) => handleChange('label', e)}
          placeholder={t('common.name')}
          size="small"
        />
        <hr />
        <PureSwitcher
          isChecked={required}
          label={[t('formBuilder.requiredForFill'), t('formBuilder.requiredForFill')]}
          onChange={(value) => handleSwitchChange('required', value)}
          position="left"
        />
      </form>
    </FormikContext.Provider>
  )
}
